<template>
  <div class="container-fluid vh-100 overflow-auto">
    <router-view />
    <div id="navBar" class="navBar vh-100">
      <div class="icon">
        <ul>
          <li>
            <router-link to="/backstage">
              <i class="las la-lg la-campground"></i>
            </router-link>
          </li>
          <li>
            <router-link to="/">
              <i class="las la-lg la-clipboard-list"></i>
            </router-link>
          </li>
          <li>
            <router-link to="/increase">
              <i class="las la-lg la-user-plus"></i>
            </router-link>
          </li>
          <li>
            <router-link to="/setting">
              <i class="las la-lg la-wrench"></i>
            </router-link>
          </li>
          <li>
            <a href>
              <i class="las la-lg la-question"></i>
            </a>
          </li>
          <li @click.prevent="signOut">
            <router-link to="/">
              <i class="las la-lg la-sign-out-alt"></i>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="text">
        <ul>
          <li>
            <router-link to="/backstage">首頁</router-link>
          </li>
          <li>
            <a href="#">黑名單</a>
          </li>
          <li>
            <router-link to="/increase">時段/角色</router-link>
          </li>
          <li>
            <router-link to="/setting">設定</router-link>
          </li>
          <li>
            <a href="#">聯絡我們</a>
          </li>
          <li @click.prevent="signOut">
            <router-link to="/">登出</router-link>
          </li>
        </ul>
      </div>
      <div class="info">
        <div class="logo">
          <img src="@/assets/img/logo.png" alt="Logo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {
    signOut () {
      localStorage.removeItem('status')
      sessionStorage.removeItem('admin')
      this.$swal({
        position: 'top-end',
        background: '#F7ECEB',
        icon: 'success',
        title: '成功登出',
        showConfirmButton: false,
        toast: true,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener('mouseenter', this.$swal.stopTimer)
          toast.addEventListener('mouseleave', this.$swal.resumeTimer)
        }
      })
    }
  },
  created () {
    const data = JSON.parse(localStorage.getItem('userEmail'))
    if (data !== null) {
      this.rememberMe = true
      this.signInMail = data
    }
  }
}
</script>

<style lang="scss">
.navBar {
  height: 100%;
  position: fixed;
  left: -2em;
  top: 0;
  z-index: 1000;
  transform-style: preserve-3d;
  perspective: 1000px;
}
.icon {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 990;
  height: 100%;
  background: #545871;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;

  & li {
    border-bottom: 1px solid rgba(184, 129, 125, 0.521);
    list-style-type: none;
  }
  & a {
    display: block;
    width: 64px;
    height: 64px;
    line-height: 64px;
    text-align: center;
    font-size: 1.6em;
    color: rgba(184, 129, 125, 0.712);
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.274);
    transition: all 0.5s ease-out;

    &:hover {
      color: #b8817d;
      transform: translateX(10px) scale(1.2);
    }
  }
}

.navBar:hover .text {
  transform: rotateY(0deg);
}
.text {
  position: absolute;
  left: 63px;
  top: 0;
  z-index: 980;
  height: 100%;
  background: #545871;
  border-right: 1px solid rgba(184, 129, 125, 0.521);
  transition: transform 0.24s linear;
  backface-visibility: hidden;
  transform-origin: left;
  transform: perspective(1000px) rotateY(90deg);
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;

  & li {
    border-bottom: 1px solid rgba(184, 129, 125, 0.521);
  }
  & a {
    display: block;
    width: 200px;
    height: 64px;
    line-height: 64px;
    text-indent: 1em;
    font-size: 1.4em;
    text-decoration: none;
    color: rgba(184, 129, 125, 0.712);
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.274);
    transition: all 0.5s ease;

    &:hover {
      color: #b8817d;
      transform: translateX(-14px);
    }
  }
}

.navBar:hover .info {
  left: 0;
  opacity: 1;
  transition: opacity 0.5s ease-in 0.1s;
}
.navBar:hover .logo img {
  display: block;
}
.info {
  position: absolute;
  padding-left: 2em;
  bottom: 30px;
  z-index: 999;
  width: 264px;
  color: hsla(255, 255%, 255%, 1);
  text-align: center;
  line-height: 1.6;
  opacity: 0;

  .logo img {
    float: right;
    display: none;
  }
}
</style>
